export const TRANSACTION_SIDEBAR_CONSTANTS = {
    ITEM_HEIGHT: 72, 
    PADDING_BUFFER: 12, 
    MIN_ITEMS: 1, 
    
    RESIZE_DEBOUNCE_DELAY: 100, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    FAST_PAGE_JUMP: 5, 
    
    TITLE: 'User Transactions',
    SEARCH_PLACEHOLDER: 'Search Users...',
    NO_USER_SELECTED: 'Select a user to view transaction history',
    
    PAGINATION_BUTTON: {
      MIN_WIDTH: '36px',
      PADDING_X: 1
    },
    
    AVATAR: {
      WIDTH: 40,
      HEIGHT: 40,
      MARGIN_RIGHT: 1.5
    },
    
    SEARCH_FIELD: {
      MARGIN_BOTTOM: 1,
      BORDER_RADIUS: 3,
      PADDING: 1
    }
  } as const;